module.exports = __webpack_public_path__ + "img/Avatar-23.de2a09c8.gif";